// A Select value distinct from a real gym-program id. The API maps this to
// the Member Explorer's `is_empty` operator.
export const EMPTY_PROGRAM_FILTER = '__no_gym_program__';
